<script setup>
import { computed } from "vue";

const props = defineProps({
  // 'outline' = unselected/default  |  'filled' = selected/active
  variant: { type: String, default: "outline" },
  // 'default' | 'secondary'
  colorScheme: { type: String, default: "default" },
  shadow: { type: Boolean, default: false },
  iconOnly: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  // Renders as button by default; pass 'a' or 'span' for other contexts
  tag: { type: String, default: "button" },
});

defineEmits(["click"]);

const classes = computed(() => [
  "ca-chip",
  `ca-chip--${props.variant}`,
  props.colorScheme === "secondary" && "ca-chip--secondary",
  props.shadow && "ca-chip--shadow",
  props.iconOnly && "ca-chip--icon-only",
  props.loading && "is-loading",
]);
</script>

<template>
  <component
    :is="tag"
    :class="classes"
    :disabled="tag === 'button' ? disabled : undefined"
    :aria-disabled="tag !== 'button' && disabled ? 'true' : undefined"
  >
    <!-- Optional left icon -->
    <span v-if="$slots.icon" class="ca-chip__icon">
      <slot name="icon" />
    </span>

    <!-- Label text -->
    <slot />

    <!-- Optional numeric badge (e.g. count) -->
    <span v-if="$slots.badge" class="ca-chip__badge">
      <slot name="badge" />
    </span>
  </component>
</template>

